import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from '@ui/layout/navbar/navbar.component';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { submenu } from './sub.menu';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';
import { RoutingQueryParamsName } from '@core/router/routing.params';

const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        component: NavbarComponent,
        outlet: 'navbar',
        data: {
            subMenuItems: submenu,
        },
    },
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Discounts,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Discounts,
        title: marker('modules.discounts.head'),
        loadComponent: () => import('./features/discounts/discounts.component').then((c) => c.DiscountsComponent),
        canLoad: [AuthGuard],
    },
    {
        path: RouteEntity.Discounts + '/' + RouteEntity.Add,
        title: marker('modules.discounts.head'),
        loadComponent: () =>
            import('./features/discounts-program-add/discounts-program-add.component').then((c) => c.DiscountsProgramAddComponent),
        canLoad: [AuthGuard],
    },
    {
        path: RouteEntity.Discounts + '/:' + RoutingQueryParamsName.PrgId,
        title: marker('modules.discounts.head'),
        loadChildren: () => import('./features/discount/discount-routing.routes').then((r) => r.routes),
        canLoad: [AuthGuard],
    },
    ...commonErrorRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
